import { Colors } from './styled';

export function colors(): Colors {
  return {
    // text
    text0: '#000000',
    text1: '#818181',
    text2: '#FCFAF2',
    text3: '#5BAD92',

    // backgrounds
    bg0: '#FCFAF2',
    bg1: '#5BAD92',
    bg2: '#F9AEA5',

    error: '#FD4040',
    success: '#27AE60',
    warning: '#ff8f00',
  };
}
